import React from 'react';
import { Redirect } from "react-router-dom";
import PropTypes from 'prop-types';
import request from '../../utils/agent';
import { Formik, Field, FieldArray, Form } from 'formik';
import * as Yup from 'yup';
import SelectorInput from 'components/SelectorInput';
import Wizard from './Wizard';
import ResellerForm from './ResellerForm';
import DistributorForm from './DistributorForm';
import DeveloperForm from './DeveloperForm';
import ArchitectForm from './ArchitectForm';
import IconBoxRow from 'components/IconBoxRow';
import './UserSignupHome.scss';



export default class UserSignupHome extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            roleInputVal: " ",
            clicked: false,
            resellerSelected: 'unselected',
            distributorSelected: 'unselected',
        }
        this.handleRoleChange = this.handleRoleChange.bind(this);
        this.handleResellerSelected = this.handleResellerSelected.bind(this);
        this.handleDistributorSelected = this.handleDistributorSelected.bind(this);
    }

    loadGoogleMaps = () => {
        var script = document.createElement('script');
        script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyAf6G6eJvy-QDsPf9-ssNiykkMH89Fbbgo&libraries=places";
        document.getElementsByTagName('head')[0].appendChild(script);
    }

    componentDidMount() {
        this.loadGoogleMaps();
        window.scrollTo(0,0);
    }



    handleRoleChange(event) {
        this.setState({roleInputVal: event.target.value});
    }

    handleResellerSelected(event) {
        event.preventDefault();
        this.setState({
            clicked: true,
            resellerSelected: 'selected',
        })
    }
    handleDistributorSelected(event) {
        event.preventDefault();
        this.setState({
            clicked: true,
            distributorSelected: 'selected',
        })
    }

    render() {

        //console.log('clicked', this.state.clecked);
        //console.log('reseller', this.state.resellerSelected);
        //console.log('distributor', this.state.distributorSelected);


        const textBox1 = [
            "Authorizes Resale of NOON products",
            "Certifies company to complete install",
            "Placement on “Where to Buy” network",
            "Sell directly to consumers",
        ];

        const textBox2 = [
            "Wholesale purchasing of NOON products",
            "Sell to NOON Authorized Pros",
            "No direct consumer sales",
        ];


        const SignUpBoxes = [
            {
                img: "https://s3-us-west-2.amazonaws.com/com-noonhome-web/dev/ProductsPro/footer/house-icon1.png",
                title: "NOON PRO",
                subtitle: "Installer",
                content:  <div><p className='box-text'>Authorizes Resale of NOON products</p><p className='box-text'>Certifies company to complete install</p><p className='box-text'>Placement on “Where to Buy” network</p><p className='box-text'>Sell directly to consumers</p></div>,
                ctalabel: "APPLY",
                ctaroute: "",
                onClickFunc: this.handleResellerSelected,
            },
            {
                img: "https://s3-us-west-2.amazonaws.com/com-noonhome-web/dev/ProductsPro/footer/house-icon3.png",
                title: "NOON PRO",
                subtitle: "Distribution",
                content:  <div><p className='box-text'>Wholesale purchasing of NOON products</p><p className='box-text'>Sell to NOON Authorized Pros</p><p className='box-text'>No direct consumer sales</p></div>,
                ctalabel: "APPLY",
                ctaroute: "",
                onClickFunc: this.handleDistributorSelected,
            }
        ];


        const roleOpts = [
            { id: ' ', display: 'Please Select Your Role...' },
            { id: 'user', display: 'Authorized Reseller (Electrician or Custom Integrator)' },
            { id: 'distributor', display: 'Distributor' },
    ];

        return(
            <section className='signup-page--holder'>
                {this.state.clicked === false ?
                    <div className='whiteBox--container'>
                        <IconBoxRow
                            boxes={SignUpBoxes}
                        />
                    </div>:
                    <div className='whiteBox--container'>
                        {this.state.resellerSelected === 'selected' ?
                            <ResellerForm/>: null
                        }
                        {this.state.distributorSelected === 'selected' ?
                            <DistributorForm/>: null
                        }
                    </div>
                }
            </section>
        );
    }

};


// WEBPACK FOOTER //
// ./src/routes/UserSignupHome/index.js